export const frontmatter = {
    "draft": false,
    "title": "Plans",
    "description": "Plan management in OnnIA.",
    "sidebar_label": "Plans",
    "sidebar_group": "reference",
    "sidebar_order": 4
}

export const toc = []